module.exports = __webpack_public_path__ + "e48fbb9e72d1889a4bef78656d071838.png";